
export const dimensions = [
    { code: "D_RB_BU_SBU", name: "SBU" },
    { code: "D_RB_CUST", name: "Customer" },
    { code: "D_RB_OMBU", name: "OMBU" },
    { code: "D_RB_PROD", name: "Product" },
    { code: "D_RB_SOG", name: "SOG" }];

export const Separators = {
    column: String.fromCharCode(180),
    row: String.fromCharCode(188),
    in: String.fromCharCode(181),
};

export const PageNames = (name: string) => {
    let pName = name;
    switch (name.toLowerCase()) {
        case "columnrestrictions":
            pName = "Column Restrictions";
            break;
    }
    return pName;
}

export const LabelConstants = {
    RoleGroups: "Security Groups",
    roleGroupLabels: {
        RoleRoleGroup: "Security Groups",
        roleIDS: "Roles",
        roleGroupID: "Security Group Id",
        roleGroupName: "Name",
        roleGroupDescription: "Description",
        createdBy: "Created/Updated By",
        createdAt: "Created/Updated On"
    },
    userRequestLabel: {
        stagingUserID: "Staging Id",
        managerUserID: "Manager",
        managerExt: "Manager Extension",
        userFirstName: "First Name",
        userName: "User Name",
        userLastName: "Last Name",
        email: "Email",
        role: "Role",
        userExt: "Extension",
        boNeeded: "BO Needed",
        requestDate: "Requested On",
        replacingFormerUser: "Replace Former User",
        formerUserID: "Former User",
        status: "Status",
        statusComment: "Comment",
        applicationAccess: "App Access",
        bOLicenceUserID: "BO License User",
        internationalOnly: "International Only",
        customerDimension: "Customer Dimension",
        createdAt: "Created On",
        approvedAt: "Approved/Rejected On",
        dimesionsRoles: "Roles",
        sections: "Sections",
        userRequestedBy: "Requested By",
        userApprovedBy: "Approved/Rejected By",
        roleGroups: "Security Groups",
        isAdUser: "Ad User",
        aComment: "Approval Comment",
        rComment: "Rejection Comment",
        replaceRoles: "Replace Role",
        action: "Action",
        symabolicID: "Symbolic Id",
        userIDAlias: "User Id Alias",
        password: "Password",
        languageCode: "Language Code",
        currencyCode: "Currency Code",
        defaultMobilePage: "Default Mobile Page",
        enableExpertEntry: "Enable Expert Entry",
        navigatorHomepage: "Navigator Home Page",
        processProfile: "Process Profile",
        primary: "Primary",
        rowSecurity: "Row Security"
    },
    userLabels: {
        userID: "User",
        byUser: "Changed By",
        userName: "User Name",
        userFirstName: "First Name",
        userLastName: "Last Name",
        email: "Email",
        password: "Password",
        passwordHash: "Password",
        role: "Roles",
        product: "Product",
        status: "Status",
        createdBy: "Created By",
        createdAt: "Modified Date",
        isAdUser: "AD User",
        applicationAccess: "Application Access",
        UserRole: "Roles",
        isApprover: "Can Approve Request",
        userRequestedBy: "Requested By",
        replaceRoles: "Replace Roles",
        userApprovedBy: "Approved By",
        aComment: "Comment",
        rComment: "Comment",
        UserRoleGroup: "Security Groups",
        managerUserID: "Manager Name"
    },
    roleLabels: {
        roleID: "Role Id",
        apiState: "API State",
        filterCode: "Filter Code",
        roleCode: "Role Code",
        roleName: "Role Name",
        description: "Description",
        roleType: "Role Type",
        weight: "Weight",
        sqlObjectIDPrefix: "Prefix",
        effectiveDate: "Effective Date",
        status: "Status",
        dataMapCode: "Dimension",
        notes: "Notes",
        filterRules: "Rules",
        filterConditions: "Conditions"
    },
    reportDiestributionLabels: {
        distributionSchedule: "Schedule",
        reportDistributionID: "Id",
        reportID: "Report Id",
        distributionName: "Distribution Name",
        distributionUsers: "Users",
        isActive: "Active",
        nextRunAt: "Next Run At",
        lastRunAt: "Last Run at",
        lastStatus: "Last Status",
        lastErrorMessage: "Error Message",
        createdBy: "Created By",
        createdAt: "Created/Updated On",
        format: "Format",
        progress: "Progress"
    },
    reportsLabel: {
        createdAt: "Created/Updated on",
        isActive: "Status",
        workspaceName: "Workspace Name",
        reportAutoID: "Report Auto Id",
        reportID: "Report Id",
        reportName: "Report Name",
        progress: "Progress",
        workspaceID: "Workspace Id",
        webUrl: "URL",
        embedUrl: "Embeded URL",
        datasetId: "Dataset Id",
        datasetWorkspaceId: "Dataset Workspace Id",
        createdBy: "Created By",
        processing: "Processing"
    }
}


export const themeColors = {
    tableBg: "#fff",
    primary: '#0078d4',
    secondary: '#6c757d',
    accent: '#28a745',
    background: '#f8f9fa',
    text: '#212529',
    border: '#dee2e6',
    selected: "#d0ebff",
    button: "#0078d4",
    buttonText: "#fff"
};

export enum fieldType {
    text, dropdown, date
}

export const getRoleAccessLabel = (value: any) => {
    if (value >= 8) return 'High Access (Admin)';
    if (value >= 4) return 'Medium Access (Power User)';
    if (value > 0) return 'Low Access (Restricted)';
    return 'No Access';
};

export const rolesByDimension = {
    D_RB_BU_SBU: [
        { name: 'SBU Analyst', description: 'Analyzes business units' },
        { name: 'SBU Manager', description: 'Manages SBU operations' },
    ],
    D_RB_CUST: [
        { name: 'Customer Viewer', description: 'View customer data' },
        { name: 'Customer Admin', description: 'Admin rights for customers' },
    ],
    D_RB_OMBU: [
        { name: 'Operations Lead', description: 'Leads ops teams' },
    ],
    D_RB_PROD: [
        { name: 'Product Owner', description: 'Owns product roadmap' },
    ],
    D_RB_SOG: [
        { name: 'SOG Controller', description: 'Controls strategic groups' },
    ]
};

export const rolesByDimensionItems = {
    D_RB_BU_SBU: [
        {
            name: 'SBU Analyst',
            description: 'Analyzes business units',
            weight: Math.random() * 100,  // Random weight between 0 and 100
            conditions: [
                { field: 'Product ID', operator: '=', value: 'GRC042736' },
                { field: 'Product Long Description', operator: 'Like', value: '%ICM%' }
            ]
        },
        {
            name: 'SBU Manager',
            description: 'Manages SBU operations',
            weight: Math.random() * 100,  // Random weight between 0 and 100
            conditions: [
                { field: 'Product ID', operator: '=', value: 'GRC042736' },
                { field: 'Product Long Description', operator: 'Like', value: '%ICM%' }
            ]
        },
    ],
    D_RB_CUST: [
        {
            name: 'Customer Viewer',
            description: 'View customer data',
            weight: Math.random() * 100,  // Random weight between 0 and 100
            conditions: [
                { field: 'Product ID', operator: '=', value: 'GRC042736' },
                { field: 'Product Long Description', operator: 'Like', value: '%ICM%' }
            ]
        },
        {
            name: 'Customer Admin',
            description: 'Admin rights for customers',
            weight: Math.random() * 100,  // Random weight between 0 and 100
            conditions: [
                { field: 'Product ID', operator: '=', value: 'GRC042736' },
                { field: 'Product Long Description', operator: 'Like', value: '%ICM%' }
            ]
        },
    ],
    D_RB_OMBU: [
        {
            name: 'Operations Lead',
            description: 'Leads ops teams',
            weight: Math.random() * 100,  // Random weight between 0 and 100
            conditions: [
                { field: 'Product ID', operator: '=', value: 'GRC042736' },
                { field: 'Product Long Description', operator: 'Like', value: '%ICM%' }
            ]
        },
    ],
    D_RB_PROD: [
        {
            name: 'Product Owner',
            description: 'Owns product roadmap',
            weight: Math.random() * 100,  // Random weight between 0 and 100
            conditions: [
                { field: 'Product ID', operator: '=', value: 'GRC042736' },
                { field: 'Product Long Description', operator: 'Like', value: '%ICM%' }
            ]
        },
    ],
    D_RB_SOG: [
        {
            name: 'SOG Controller',
            description: 'Controls strategic groups',
            weight: Math.random() * 100,  // Random weight between 0 and 100
            conditions: [
                { field: 'Product ID', operator: '=', value: 'GRC042736' },
                { field: 'Product Long Description', operator: 'Like', value: '%ICM%' }
            ]
        },
    ]
};

export const IsAdminUser = (user) => {
    if (typeof user != 'undefined') {
        let adminUsers = ["admin", "roshan jha", "santosh pp", "naman sinha", "prashant kumar"];
        return (user.applicationAccess == 2)
        //return (user.email.indexOf("sm") > -1 || user.email.indexOf("mj") > -1);
    }
    return false;
}

export const OPERATOR_LABELS: Record<string, string> = {
    '=': 'Equals',
    'like': 'Contains',
    'startwith': 'Starts with',
    'endwith': 'Ends with',
    'in': 'In',
    'not in': 'Not in'
};

export enum UserType {
    User = 0,
    Manager = 1,
    Admin = 2
};

export const allAccessRoleID = {
    D_RB_BU_SBU: 100001,
    D_RB_CUST: 100002,
    D_RB_OMBU: 100003,
    D_RB_PROD: 100004,
    D_RB_SOG: 100005,
}

export const AccessTypes = [{
    id: 0,
    value: "User",
}, {
    id: 1,
    value: "Direct Manager"
},
{
    id: 2,
    value: "Admin"
}];

export function getAPIUrl() {
    const { href } = window.location;
    https://rainbirdapi.azurewebsites.net/Api/Values/GetUserRoles?userID=2
    //return "http://127.0.0.1:5000/api"
    return process.env.REACT_APP_API_URL
    // if (href.toLowerCase().indexOf('dev') > -1 || href.toLowerCase().indexOf('127.0.0.1') > -1)
    //     return "https://rainbirdapidev.azurewebsites.net/api";
    // if (href.toLowerCase().indexOf('localhost') == -1)
    //     return "https://rainbirdapi.azurewebsites.net/api";
    // return "http://localhost:7070/api";
}

export function getRedirectURL() {
    const { origin } = window.location;
    return origin;
}

// constants/routes.ts
export const ROUTE_HIERARCHY = {
    "home": {
        title: "Home",
        path: "/",
        children: {
            "requests": {
                title: "Approvals",
                path: "/requests",
                children: {
                    "create": {
                        title: "Create new Request",
                        path: "/requests/create"
                    }
                }
            },
            "users": {
                title: "Users",
                path: "/users"
            },
            "roles": {
                title: "Roles",
                path: "/roles",
                children: {
                    "roledetails": {
                        title: "Role Editor",
                        path: "/roles/roledetails"
                    }
                }
            },
            "settings": {
                title: "Settings",
                path: "/settings"
            },
            "analytics": {
                title: "Analytics",
                path: "/analytics"
            }
        }
    }
};